import { Trans, t } from '@lingui/macro';
import { Box, Stack, Typography } from '@mui/material';
import type { UsersT } from '@prismo-io/schemas';
import { IsInVigijobsAction } from '../api/is-in-vigijobs.action';
import { IsMeAction } from '../api/is-me.action';
import { CustomModal } from '../modal/index';
type Props = {
  formId: string;
  user: Pick<UsersT, 'id' | 'url'>;
  order?: number;
};
export const GoogleFormCard = async (props: Props) => {
  const {
    formId,
    user,
    order = 100000000
  } = props;
  const res = await IsMeAction({
    userId: user.id
  });
  if (!res?.data) {
    return null;
  }
  const isMe = res.data;
  if (!isMe) {
    return null;
  }
  const {
    data: isInVigijobs
  } = (await IsInVigijobsAction({
    userId: user.id
  }))!;
  if (!isInVigijobs) {
    return null;
  }
  return <Stack component="article" bgcolor="background.paper" borderRadius="3rem" p={2} zIndex={10} minWidth={{
    none: '100%',
    sm: '45%',
    lg: '31%'
  }} height="100%" minHeight="18rem" boxShadow="2px 2px 7px 0px rgba(0,0,0,0.3)" flex="1 1 0%" direction="column" alignItems="center" justifyContent="center" order={order} gap={2} data-sentry-element="Stack" data-sentry-component="GoogleFormCard" data-sentry-source-file="index.tsx">
      <CustomModal data-sentry-element="CustomModal" data-sentry-source-file="index.tsx">
        <Box component="iframe" border="none" minWidth={{
        none: '100vw',
        md: '75vw',
        lg: '50vw'
      }} minHeight={{
        none: '100vh',
        md: '90vh'
      }} src={`https://docs.google.com/forms/d/e/${formId}/viewform?usp=sf_link`} allowFullScreen data-sentry-element="Box" data-sentry-source-file="index.tsx" />
      </CustomModal>
      <Typography fontWeight="bold" data-sentry-element="Typography" data-sentry-source-file="index.tsx">{t`Ajouter des outils`}</Typography>
    </Stack>;
};